<nb-layout windowMode>
  <nb-layout-header></nb-layout-header>
  <nb-layout-column>
    <ng-content select="router-outlet"></ng-content>
  </nb-layout-column>
  <nb-layout-footer></nb-layout-footer>
</nb-layout>
